import React from 'react'

import { latest as API_URL } from '../config/api';
import moment from 'moment';
import { isChecked, number_format, panels } from '../config/Helpers';
import ListDynamic from '../reports/ListDynamic';
import ExportReport from '../reports/ExportReport';
import { Icon, Popconfirm, message, Button, Select, Drawer } from 'antd';
import ListFixed from '../reports/ListFixed';
import { HashLink as Link } from 'react-router-hash-link';
import axios from 'axios';


const postUrlDimensions  = API_URL + 'dimensions';

class SidebarLeft extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            items : {
                brand : 'inactive',
                region : 'inactive',
                resort : 'inactive',
                business : 'inactive',
                reserve : 'inactive',
                plan : 'inactive',
                tariff : 'inactive',
                room : 'inactive',
                segment : 'inactive',
                type_room : 'inactive',
                tariff_type : 'inactive',
                channel : 'inactive',
                agency : 'inactive',
                market : 'inactive',
                territory : 'inactive'
            },
            sidebar_loading : ' ',
            current_side : '',
            brands_filter : [],
            region_filter : [],
            resort_filter : [],
            business_line_filter : [],
            channels_filter : [],
            segments_filter : [],
            plan_filter : [],
            type_room_filter : [],
            tariff_type_filter : [],
            type_reserve_filter : [],
            agencies_filter : [],
            markets_filter : [],
            territory_filter : [],
            business_units_filter : [],
            sidebar_active : 'inactive-sidebar',
            channels_by_sgm  : [],
            channels_by_sgm_aux : [],
            rooms_by_property : [],
            rooms_by_property_aux : [],
            territory : [],
            segments : [],
            properties : [],
            filter_value_segment : '',
            filter_value_property : '',
            _report : {
                active : false,
                edit : false,
                share : false
            },
            select_module : ''
        };
        this.isCheckedSegment = this.isCheckedSegment.bind(this)
        this.getChannels = this.getChannels.bind(this)
        this.getRooms = this.getRooms.bind(this)
        this.getDefaultValues = this.getDefaultValues.bind(this);
        this.getFilters = this.getFilters.bind(this)
        this.getResetValues = this.getResetValues.bind(this);
    }
    
    getDefaultValues(){
        return {
            channels_by_sgm: [],
            rooms_by_property : [],
            segments: [],
            properties : [],
            sidebar_active : 'inactive-sidebar',
            sidebar : '',
            sidebar_loading : ' ',
            current_side : '',
        };
    }
    getResetValues(){
        return {
            items : {
                brand: 'inactive',
                region : 'inactive',
                resort : 'inactive',
                business : 'inactive',
                reserve : 'inactive',
                plan : 'inactive',
                tariff : 'inactive',
                room : 'inactive',
                segment : 'inactive',
                type_room : 'inactive',
                tariff_type : 'inactive',
                channel : 'inactive',
                agency : 'inactive',
                market : 'inactive',
                territory : 'inactive'
            },
            sidebar_loading : ' ',
            current_side : '',
            brands_filter : [],
            region_filter : [],
            resort_filter : [],
            business_line_filter : [],
            channels_filter : [],
            segments_filter : [],
            plan_filter : [],
            type_room_filter : [],
            tariff_type_filter : [],
            type_reserve_filter : [],
            agencies_filter : [],
            markets_filter : [],
            territory_filter : [],
            business_units_filter : [],
            sidebar_active : 'inactive-sidebar',
            channels_by_sgm : [],
            channels_by_sgm_aux : [],
            rooms_by_property : [],
            rooms_by_property_aux : [],
            segments : [],
            properties : [],
            territory : [],
            filter_value_segment : '',
            filter_value_property : '',
            _report : {
                active : false,
                edit : false,
                share : false
            }
        }
    }
    getFilters(){
        if(this.props.app.state.new_date === false){
            return;
        }
        let self = this;
        var qs = require('qs');
        self.setState({
            sidebar_loading : ' '
        }, function(){
            axios.post(postUrlDimensions, qs.stringify(self.props.app.currentFilters({ type : 'sidebar' })))
            .then(function (response){ 
                self.setState({ 
                    brands_filter : Object.keys(response.data['brand']).length > 0 ? response.data['brand'] : [],
                    region_filter : Object.keys(response.data['region']).length > 0 ? response.data['region'] : [],
                    resort_filter : Object.keys(response.data['property']).length > 0 ? response.data['property'] : [],
                    business_line_filter : Object.keys(response.data['business-line']).length > 0 ? response.data['business-line'] : [],
                    segments_filter : Object.keys(response.data['segments']).length > 0 ? response.data['segments'] : [],
                    channels_filter : Object.keys(response.data['channels']).length > 0 ? response.data['channels'] : [],
                    type_room_filter : Object.keys(response.data['room_type']).length > 0 ? response.data['room_type'] : [],
                    tariff_type_filter : Object.keys(response.data['tariff_type']).length > 0 ? response.data['tariff_type'] : [],
                    agencies_filter : Object.keys(response.data['agency']).length > 0 ? response.data['agency'] : [],
                    markets_filter : Object.keys(response.data['market']).length > 0 ? response.data['market'] : [],
                    territory_filter : Object.keys(response.data['territory']).length > 0 ? response.data['territory'] : [],
                    plan_filter : Object.keys(response.data['plan']).length > 0 ? response.data['plan'] : [],
                    type_reserve_filter : Object.keys(response.data['type_reserve']).length > 0 ? response.data['type_reserve'] : [],
                    channels_filter_aux : Object.keys(response.data['channels']).length > 0 ? response.data['channels'] : [],
                    brands_filter_aux : Object.keys(response.data['brand']).length > 0 ? response.data['brand'] : [],
                    region_filter_aux : Object.keys(response.data['region']).length > 0 ? response.data['region'] : [],
                    resort_filter_aux : Object.keys(response.data['property']).length > 0 ? response.data['property'] : [],
                    business_line_filter_aux : Object.keys(response.data['business-line']).length > 0 ? response.data['business-line'] : [],
                    segments_filter_aux : Object.keys(response.data['segments']).length > 0 ? response.data['segments'] : [],
                    type_reserve_filter_aux : Object.keys(response.data['type_reserve']).length > 0 ? response.data['type_reserve'] : [],
                    type_room_filter_aux : Object.keys(response.data['room_type']).length > 0 ? response.data['room_type'] : [],
                    tariff_type_filter_aux : Object.keys(response.data['tariff_type']).length > 0 ? response.data['tariff_type'] : [],
                    agencies_filter_aux : Object.keys(response.data['agency']).length > 0 ? response.data['agency'] : [],
                    markets_filter_aux : Object.keys(response.data['market']).length > 0 ? response.data['market'] : [],
                    territory_filter_aux : Object.keys(response.data['territory']).length > 0 ? response.data['territory'] : [],
                    plan_filter_aux : Object.keys(response.data['plan']).length > 0 ? response.data['plan'] : [],
                    mount : true,
                    sidebar_loading : ' hide'
                }) 
            })
        })
    }
    confirm(edit = false) {
        let self = this

        this.setState({
            _report : {
                active : true,
                edit : edit,
                share : false
            },
        }, function(){
            this.props.app.setState((prev) => {
                return {
                    report_context : {
                        _id : prev.report_context._id, 
                        status : true,
                        className : 'report-context',
                        name : prev.report_context.name,
                        type_report : prev.report_context.type_report,
                        analysis_interval : prev.report_context.analysis_interval,
                        notify_email :prev.report_context.notify_email,
                        startValue : prev.report_context.startValue,
                        endValue : prev.report_context.endValue,
                        days_fixed_report : prev.report_context.days_fixed_report
                    }
                }
            }, function(){
                if(edit === true){
                    self.props.app.mainRequest();
                }else{
                    message.info('Now you can create your report');
                }
                self.handleClickSidebar('dimensions')
            })
        })
      }

    handleClickModal(type){
        let self = this;
        this.props.reportModelState(type)
    }
    isCheckedSegment(){
        let result = false;
        let self = this;
        let count_channels = Object.keys(this.props.current_filter_channel).length - 1;
        let segments = [];
        if(count_channels > -1){
            Object.keys(this.props.current_filter_channel).map(function(key, index){
                let key_segment = key.split('-')[1];
                if(segments[key_segment] === undefined){
                    segments[key_segment] = key_segment
                }
                if(count_channels === index){
                    Object.keys(segments).map(function(elem){
                        self.setState({ segments : segments });
                    })
                }
            })
        }else{
            self.setState({segments : [] });
        }
        
        return result;
    }

    filterDimensionByText(ref_state, event){
        let filter = event.target.value;
        if(ref_state !== 'segments_filter' && ref_state !== 'resort_filter'){
            this.setState({
                [ref_state] : this.state[ref_state + '_aux']
            }, function(){
                let array_elements = this.state[ref_state].filter(function(elem) {
                    return elem.name.toLowerCase().indexOf(filter.toLowerCase()) != -1; // returns true or false
                });
                if(filter === ''){
                    this.setState({
                        [ref_state] : this.state[ref_state + '_aux']
                    })
                }else{
                    this.setState({
                        [ref_state] : array_elements
                    })
                }
            })
        }else if(ref_state === 'segments_filter'){
            this.setState({
                [ref_state] : this.state[ref_state + '_aux'],
                channels_filter : this.state.channels_filter_aux
            }, function(){
                let array_segments = this.state[ref_state].filter(function(elem) {
                    return elem.name.toLowerCase().indexOf(filter.toLowerCase()) != -1; // returns true or false
                });
                let array_channels = this.state.channels_filter.filter(function(elem) {
                    return elem.name.toLowerCase().indexOf(filter.toLowerCase()) != -1; // returns true or false
                });
                if(filter === ''){
                    this.setState({
                        [ref_state] : this.state[ref_state + '_aux'],
                        channels_filter : this.state.channels_filter_aux,
                        filter_value_segment : ''
                    })
                }else{
                    this.setState({
                        [ref_state] : array_segments,
                        channels_filter : array_channels,
                        filter_value_segment : true
                    })
                }
                
            })
        }else if(ref_state === 'resort_filter'){
            this.setState({
                [ref_state] : this.state[ref_state + '_aux'],
                type_room_filter : this.state.type_room_filter_aux
            }, function(){
                let array_properties = this.state[ref_state].filter(function(elem) {
                    return elem.name.toLowerCase().indexOf(filter.toLowerCase()) != -1; // returns true or false
                });
                let array_rooms = this.state.type_room_filter.filter(function(elem) {
                    return elem.name.toLowerCase().indexOf(filter.toLowerCase()) != -1; // returns true or false
                });
                if(filter === ''){
                
                    this.setState({
                        [ref_state] : this.state[ref_state + '_aux'],
                        type_room_filter : this.state.type_room_filter_aux,
                        filter_value_property : ''
                    })
                }else{
                    this.setState({
                        [ref_state] : array_properties,
                        type_room_filter : array_rooms,
                        filter_value_property : true
                    })
                }
                
            })
        }
    }
    handleClickSidebar(sidebar) {
        let self = this;
        let state_sidebar;
        const is_report = (sidebar === 'models' || sidebar === 'reports') ? ' is-report' : '';
        this.setState(function(prev){
            if(self.state._report.active === false){
                if(prev.sidebar_active === 'active-sidebar' + is_report && prev.current_side === sidebar){
                    state_sidebar = 'inactive-sidebar';
                    sidebar = '';
                }else{
                    state_sidebar = 'active-sidebar' + is_report;
                    if(is_report === ' is-report'){ 
                        this._ListFixed.syncReports(); 
                    }
                }
            }else{
                state_sidebar = 'active-sidebar';
                sidebar = 'dimensions';
            }
            return {
                sidebar_active : state_sidebar, 
                current_side : sidebar 
            }
        }, () => {
            this.props.activeSidebar(state_sidebar)
        }); 
    }
    handleClickMenuItem(item, type){
        let array_elements, self = this;
        if(type === 'property'){
            array_elements  = self.props.current_filter_properties
        }else if(type === 'region'){
            array_elements  = self.props.current_filter_region
        }else if(type === 'reserve'){
            array_elements  = self.props.current_filter_reserve
        }else if(type === 'business'){
            array_elements  = self.props.current_filter_business
        }else if(type === 'brand'){
            array_elements  = self.props.current_filter_brand
        }else if(type === 'plan'){
            array_elements  = self.props.current_filter_plan
        }else if(type === 'segment'){
            array_elements  = self.props.current_filter_segment
        }else if(type === 'channel'){
            array_elements  = self.props.current_filter_channel
        }else if(type === 'type_room'){
            array_elements  = self.props.current_filter_type_room
        }else if(type === 'tariff_type'){
            array_elements  = self.props.current_filter_tariff_type
        }else if(type === 'agency'){
            array_elements  = self.props.current_filter_agency
        }else if(type === 'market'){
            array_elements  = self.props.current_filter_market
        }else if(type === 'territory'){
            array_elements  = self.props.current_filter_territory
        }
        if(type !== 'segment'){
            if(array_elements[item.value] === undefined)
            {
                self.props.setFilterBubble(item.text, item.value, 'hide', type)
            }else{
                self.props.setFiltersComponent(type, item.value)
            }
        }else if(type === 'segment'){
            let group_elements  = this.props.app.state.current_filter_channel;

            if(this.state.segments[item.value] === undefined)
            {
                self.state.channels_by_sgm[item.value].map(function(item_channel, index){
                    group_elements[item_channel._id + '-' + item.value]  = { 'channel' : item_channel.name, 'value' : item_channel._id + '-' + item.value }
                });
                self.props.setFilterBubble('', '', 'hide', 'segment', [group_elements, item])
            }else{
                self.state.channels_by_sgm[item.value].map(function(item_channel, index){
                    delete group_elements[item_channel._id + '-' + item.value];
                });
                self.props.setFiltersComponent('segment', '', [group_elements, item])
            }
        }
    } 
    handleClickItemSidebar(item) {
        let self       = this;
        let new_state   = {};
        Object.keys(self.state.items).map(function(key){
            if(key === item){
                new_state[key]  = self.state.items[key] === 'active' ? 'inactive' : 'active';
            }else{
                new_state[key]  = 'inactive'
            }
        });

        self.setState({
            items : new_state
        })
    }
    getChannels(item_aux){
        let self = this;
        let id_major = item_aux._id;
        self.state.channels_by_sgm[id_major] = item_aux.channels;
        self.state.channels_by_sgm_aux[id_major] = item_aux.channels;
        if(item_aux.channels !== undefined){
            return item_aux.channels.map((item, index) =>
                <li  key={'list-channels-aux-'+index} onClick={self.handleClickMenuItem.bind(self, { text: item.name, value: item._id + '-' + id_major }, 'channel')}>
                    <span className='title-list'>{ item.name } <span className='total-by-filter' children={`(${number_format(item.total,0)})`}/></span>
                    <input type='checkbox' 
                        checked={isChecked(self.props.current_filter_channel, item._id + '-' + id_major)} 
                        value={ item._id }  
                    />
                    <span className='checkmark'></span>
                </li>
            )
        }
    }
    getRooms(item_aux){
        let self   = this;
        let id_major = item_aux.name;
        self.state.rooms_by_property[id_major] = item_aux.rooms;
        self.state.rooms_by_property_aux[id_major] = item_aux.rooms;
        if(item_aux.rooms !== undefined){
            return item_aux.rooms.map((item, index) =>
                <li  key={'list-channels-aux-'+index} onClick={self.handleClickMenuItem.bind(self, { text: item.name, value: item._id + '||' + id_major }, 'type_room')}>
                    <span className='title-list'>{ item.name } <span className='total-by-filter' children={`(${number_format(item.total,0)})`}/></span>
                    <input type='checkbox' 
                        checked={isChecked(self.props.current_filter_type_room, item._id + '||' + id_major)} 
                        value={ item._id }  
                    />
                    <span className='checkmark'></span>
                </li>
            )
        }
    }
    
    cancelReport(){
        let msg = this.state._report.edit === false ? 'The report has been canceled.' : 'The report has been closed.';
        message.info(msg);
        this.setState(function(){
            return {
                _report : {
                    active : false,
                    edit : false,
                    share : false
                }
            }
        }, function(){
            this.props.app.setState({
                mode_report : {
                    status : false,
                    _is_share : false,
                    _is_interactive : false,
                    _is_invited : false,
                    _dashboards_select : {},
                    _allow_export : 0
                },
                report_context : {
                    status : false,
                    name : '',
                    type_report : '',
                    className : '',
                    notify_email : 0,
                    allow_export : 0,
                    datepicker : '',
                    days_fixed_report : ''
                }
            })
        })
    }

    componentWillReceiveProps(){
        let self = this;
        if(self.props.app.state.mode_report !== null){
            const Option = Select.Option;
            let _index = 0;
            const listPanels = Object.keys(panels).map((item, index) => {
                let panel_include = false, 
                panel_dashboards = self.props.app.state.mode_report._dashboards_select,
                _params_module = {};
                Object.keys(panel_dashboards).map((key, index) => {
                    let _decode = JSON.parse(panel_dashboards[key])
                    if(_decode._panel === panels[item]._value){
                        _params_module = _decode._params_module
                        panel_include = true
                    }
                })
                if(panel_include === true){
                    if(_index === 0){
                        this.state.current_panel = { _name: panels[item]._name, _icon: panels[item]._icon + '-active', _value: panels[item]._value }
                        _index++;
                    }
                    return (<Option 
                        key={panels[item]._value}
                        onClick={self.props.app._widgetHeader.handleClickMenuItem.bind(self, { _name: panels[item]._name, _icon: panels[item]._icon + '-active', _value: panels[item]._value }, 'menu_panel', _params_module)}
                    >{panels[item]._name}</Option>)
                }
            });
        
            let select_module = (
                <Select 
                    className='select-modules' style={{width : '100%'}} 
                    defaultValue={ (function(){ 
                        if(self.props.app._widgetHeader === undefined || self.props.app._widgetHeader === null){
                            return 'review'
                        } else{
                            return self.props.app._widgetHeader.state.current_panel._value
                        }
                    })()}>
                    {listPanels}
                </Select>
            );
            this.setState({
                select_module : select_module
            })
        }
    }
    render(){
        let self = this;

        const filterBrands = this.state.brands_filter === undefined ? '' : this.state.brands_filter.map(function(item, index){
            return (<li key={'filter-brand-'+index} onClick={self.handleClickMenuItem.bind(self, { text: item.name, value: item._id }, 'brand')} >
                <span className='title-list'>{ item.name } <span className='total-by-filter' children={`(${number_format(item.total,0)})`}/>
                    <input type='checkbox' 
                        value={ index } 
                        checked={isChecked(self.props.current_filter_brand, item._id)} 
                    />
                    <span className='checkmark'></span>
                </span>
            </li>)
        });

        const filterRegion = this.state.region_filter === undefined ? '' : this.state.region_filter.map((item, index) =>
            <li key={'filter-region-'+index} onClick={this.handleClickMenuItem.bind(this, { text: item.name, value: item._id }, 'region')}>
                <span className='title-list'>{ item.name } <span className='total-by-filter' children={`(${number_format(item.total,0)})`}/>
                    <input type='checkbox'
                        checked={isChecked(this.props.current_filter_region, item._id)} 
                        value={ item._id } 
                    />
                    <span className='checkmark'></span>
                </span>
            </li>
        );

        const filterBusiness = this.state.business_line_filter.map((item, index) =>
            <li key={'filter-business-'+index} onClick={this.handleClickMenuItem.bind(this, { text: item.name, value: item._id }, 'business')}>
                <span className='title-list'>{ item.name } <span className='total-by-filter' children={`(${number_format(item.total,0)})`}/>
                    <input type='checkbox' 
                        checked={isChecked(this.props.current_filter_business, item._id)} 
                        value={ item._id } 
                    />
                    <span className='checkmark'></span>
                </span>
            </li>
        );
        const filterResort = this.state.resort_filter.map((item, index) =>
            <li key={'filter-resort-'+index}>
                <span className='title-list' onClick={this.handleClickMenuItem.bind(this, { text: item.name, value: item._id }, 'property')}>{ item.name } <span className='total-by-filter' children={`(${number_format(item.total,0)})`}/>
                    <input type='checkbox' 
                        checked={isChecked(this.props.current_filter_properties, item._id)}
                    />
                    <span className='checkmark'></span>
                </span>
                <ul>
                    { this.state.filter_value_property === '' ? self.getRooms(item) : ''}
                </ul>
            </li>
        );
        const filterSegments = this.state.segments_filter.map((item, index) =>
            <li key={'filter-segment-'+index}>
                <span className='title-list' onClick={this.handleClickMenuItem.bind(this, { text: item.name, value: item._id }, 'segment')}>{ item.name } <span className='total-by-filter' children={`(${number_format(item.total,0)})`}/>
                    <input type='checkbox'
                        checked={this.state.segments[item._id] !== undefined ? true : false} 
                        value={ item._id }
                        ref={item._id} 
                        onClick={this.handleClickMenuItem.bind(this, { text: item.name, value: item._id }, 'segment')}
                    />
                    <span className='checkmark'></span>
                </span>
                <ul>
                    { this.state.filter_value_segment === '' ? self.getChannels(item) : ''}
                </ul>
            </li>
        );

        const filterReserve = this.state.type_reserve_filter.map((item, index) =>
            <li key={'filter-reserve-sidebar' + index} onClick={this.handleClickMenuItem.bind(this, { text: item.name, value: item._id }, 'reserve')}>
                <span className='title-list'>{ item.name } <span className='total-by-filter' children={`(${number_format(item.total,0)})`}/>
                    <input type='checkbox' 
                        checked={isChecked(this.props.current_filter_reserve, item._id)} 
                        value={ item._id } 
                        
                    />
                    <span className='checkmark'></span>
                </span>
            </li>
        );

        const filterPlan = this.state.plan_filter.map((item, index) =>
            <li key={'filter-plan-'+index} onClick={this.handleClickMenuItem.bind(this, { text: item.name, value: item._id }, 'plan')}>
                <span className='title-list'>{ item.name } <span className='total-by-filter' children={`(${number_format(item.total,0)})`}/>
                    <input type='checkbox'
                        checked={isChecked(this.props.current_filter_plan, item._id)} 
                        value={ item._id } 
                        
                    />
                    <span className='checkmark'></span>
                </span>
            </li>
        );

        const filterChannels = this.state.channels_filter === undefined ? '' : Object.keys(this.state.channels_filter).map((item, index) => ( 
            <li key={'list-channels-aux-'+index} onClick={self.handleClickMenuItem.bind(self, { text: self.state.channels_filter[item].name, value: self.state.channels_filter[item]._id + '-' + self.state.channels_filter[item].id_major_segment }, 'channel')}>
                <span className='title-list by-segment'>
                    <span className="segment-parent">
                        <span>{ self.state.channels_filter[item].name } </span>
                        <span>{ self.state.channels_filter[item].name_major_segment }</span> 
                    </span>
                    <span className='total-by-filter' children={`(${number_format(self.state.channels_filter[item].total,0)})`}/>
                    <input type='checkbox' 

                        checked={isChecked(self.props.current_filter_channel, self.state.channels_filter[item]._id + '-' + self.state.channels_filter[item].id_major_segment)} 
                        value={ self.state.channels_filter[item]._id }  
                    />
                    <span className='checkmark'></span>
                </span>
            </li> 
        ));

        const filterTypeRoom = this.state.type_room_filter === undefined ? '' : this.state.type_room_filter.map((item, index) =>
            <li key={'filter-type-'+index} onClick={this.handleClickMenuItem.bind(this, { text: item.name, value: item._id }, 'type_room')}>
                <span className='title-list'>{ item.name } <span className='total-by-filter' children={`(${number_format(item.total,0)})`}/>
                    <input type='checkbox'  
                        checked={isChecked(this.props.current_filter_type_room, item._id)} 
                        value={ item._id } 
                    
                    />
                    <span className='checkmark'></span>
                </span>
            </li>
        );

        const filterTypeTariff = this.state.tariff_type_filter.map((item, index) =>
            <li key={'filter-type-tariff-'+index} onClick={this.handleClickMenuItem.bind(this, { text: item.name, value: item._id }, 'tariff_type')}>
                <span className='title-list'>{ item.name } <span className='total-by-filter' children={`(${number_format(item.total,0)})`}/>
                    <input type='checkbox'  
                        checked={isChecked(this.props.current_filter_tariff_type, item._id)} 
                        value={ item._id } 
                    
                    />
                    <span className='checkmark'></span>
                </span>
            </li>
        );
        

        const filterMarkets = this.state.markets_filter === undefined ? '' : this.state.markets_filter.map((item, index) =>
            <li  key={'filter-market-'+index} onClick={this.handleClickMenuItem.bind(this, { text: item.name, value: item._id }, 'market')}>
                <span className='title-list'>{ item.name } <span className='total-by-filter' children={`(${number_format(item.total,0)})`}/>
                    <input type='checkbox' 
                        checked={isChecked(this.props.current_filter_market, item._id)} 
                        value={ item._id }
                    />
                    <span className='checkmark'></span>
                </span>
            </li>
        );
    
        const filterTerritory = this.state.territory_filter === undefined ? '' : this.state.territory_filter.map((item, index) =>
            <li  key={'filter-territory-'+index} onClick={this.handleClickMenuItem.bind(this, { text: item.name, value: item._id }, 'territory')}>
                <span className='title-list'>{ item.name } <span className='total-by-filter' children={`(${number_format(item.total,0)})`}/>
                    <input type='checkbox' 
                        checked={isChecked(this.props.current_filter_territory, item._id)} 
                        value={ item._id }
                    />
                    <span className='checkmark'></span>
                </span>
            </li>
        );
    
    const original_padding = (this.props.app.isInvitedUser() === false) ?  { style : { paddingTop : 15 } } : null;

    
    return(
        <section id='container-sidebar' {...original_padding} className={'sidebar-left ' + this.state.sidebar_active + ' ' + this.props.secondary_filter_bar}>
            { this.props.app.isInvitedUser() ?
            (<div className={'filters-section'}>
                <div className={'loading-sidebar ' + this.state.sidebar_loading}>
                    <Icon type='sync' spin />
                </div>
                <div className={(this.state._report.active === false ? '' : ' hide')} onClick={this.handleClickSidebar.bind(this, 'dimensions')}>
                    <a className='dimensions'><i className='fa fa-filter' aria-hidden='true'></i></a>
                    <span>FILTERS</span>
                    <Icon type='close' theme='outlined' className={'close-wdg ' + (this.state.current_side === 'dimensions' ? 'show' : 'hide')}/>
                </div>
                <ul className={ this.state.current_side === 'dimensions' ? 'active' : '' }>
                    {/* <li className={this.state.items.business}>
                        <span onClick={this.handleClickItemSidebar.bind(this, 'business')}>Business Unit</span>
                        <div className='sub-list'>
                            <div className=''>
                                <input 
                                    type='text' 
                                    onChange={this.filterDimensionByText.bind(this, 'business_line_filter')}  
                                    placeholder='Search...'
                                />
                            </div>
                            <ul>
                                { filterBusiness }
                            </ul>
                        </div>
                    </li> */}
                    <li className={this.state.items.brand}>
                        <span onClick={this.handleClickItemSidebar.bind(this, 'brand')}>Brand/Group</span>
                        <div className='sub-list'>
                            <div className=''>
                                <input 
                                    type='text' 
                                    onChange={this.filterDimensionByText.bind(this, 'brands_filter')}  
                                    placeholder='Search...'
                                />
                            </div>
                            <ul>
                                { filterBrands }
                            </ul>
                        </div>
                    </li>
                    <li className={this.state.items.resort}>
                        <span onClick={this.handleClickItemSidebar.bind(this, 'resort')}>Locations/Services</span>
                        <div className='sub-list'>
                            <div className=''>
                                <input 
                                    type='text' 
                                    onChange={this.filterDimensionByText.bind(this, 'resort_filter')}  
                                    placeholder='Search...'
                                />
                            </div>
                            <ul>
                                { filterResort }
                                { this.state.filter_value_property !== '' ? filterTypeRoom : '' }
                            </ul>
                        </div>
                    </li>
                    <li className={this.state.items.region}>
                        <span onClick={this.handleClickItemSidebar.bind(this, 'region')}>Region</span>
                        <div className='sub-list'>
                            <div className=''>
                                <input 
                                    type='text' 
                                    onChange={this.filterDimensionByText.bind(this, 'region_filter')} 
                                    placeholder='Search...'
                                />
                            </div>
                            <ul>
                                { filterRegion }
                            </ul>
                        </div>
                    </li>
                    
                    {/*<li className={this.state.items.reserve}>
                        <span onClick={this.handleClickItemSidebar.bind(this, 'reserve')}>Reservation status</span>
                        <div className='sub-list'>
                            <ul>
                                { filterReserve }
                            </ul>
                        </div>
                    </li>*/}
                    <li className={this.state.items.plan}>
                        <span onClick={this.handleClickItemSidebar.bind(this, 'plan')}>Pax type</span>
                        <div className='sub-list'>
                            
                            <ul>
                                { filterPlan }
                            </ul>
                        </div>
                    </li>

                    {/*<li className={this.state.items.tariff_type}>
                        <span onClick={this.handleClickItemSidebar.bind(this, 'tariff_type')}>Tariff type</span>
                        <div className='sub-list'>
                            
                            <ul>
                                { filterTypeTariff }
                            </ul>
                        </div>
                    </li>
                    <li className={this.state.items.market}>
                        <span onClick={this.handleClickItemSidebar.bind(this, 'market')}>Market</span>
                        <div className='sub-list'>
                            <div>
                                <input 
                                    type='text' 
                                    onChange={this.filterDimensionByText.bind(this, 'markets_filter')}
                                    placeholder='Search...'  
                                />
                            </div>
                            <ul>
                                { filterMarkets }
                            </ul>
                        </div>
                    </li>*/}
                    <li className={this.state.items.segment}>
                        <span onClick={this.handleClickItemSidebar.bind(this, 'segment')}>Segment/Agency</span>
                        <div className='sub-list'>
                            <div className=''>
                                <input 
                                    type='text' 
                                    onChange={this.filterDimensionByText.bind(this, 'segments_filter')}  
                                    placeholder='Search...'
                                />
                            </div>
                            <ul>
                                { filterSegments }
                                { this.state.filter_value_segment !== '' ? filterChannels : '' }
                            </ul>
                        </div>
                    </li> 

                    <li className={this.state.items.territory}>
                        <span onClick={this.handleClickItemSidebar.bind(this, 'territory')}>Territory</span>
                        <div className='sub-list'>
                            <div>
                                <input 
                                    type='text' 
                                    onChange={this.filterDimensionByText.bind(this, 'territory_filter')}
                                    placeholder='Search...'  
                                />
                            </div>
                            <ul>
                                { filterTerritory }
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>) : 
            ( <div className='report-options-view'>
                <Link to='/'><span className='logo-sidebar'> </span></Link>
                <br />
                <span className='subtitle'>AVAILABLY MODULES</span>
                {this.state.select_module}
            </div> ) 
            }

            { /*<div>
                <a className='expressions' onClick={this.handleClickSidebar.bind(this)}> <i className='fa fa-list-alt' aria-hidden='true'></i> </a>
                <span>EXPRESIONES</span>
            </div> */ }
            {/*<div className={ (this.state.current_side === 'reports' ? 'active' : '') + (this.state._report.active === false ? '' : ' hide') }>
                <div onClick={this.handleClickSidebar.bind(this, 'reports')}>
                    <a className='reports'> <i className='fa fa-clipboard' aria-hidden='true'></i> </a>
                    <span>REPORTS</span>
                    <Icon type='close' theme='outlined' className={'close-wdg ' + (this.state.current_side === 'reports' ? 'show' : 'hide')}/>
                </div>
                <ListFixed 
                    currentFilters = {this.props.app.currentFilters}
                    status={(this.state.current_side === 'reports' ? 'active' : '')}
                    layout={this}
                    app={this.props.app}
                    ref={(child) => { this._ListFixed = child; }}
                />
        </div>*/}
            <div>
                <div className={this.state._report.active === true ? '' : ' hide'} >
                    <span className={this.state._report.active === false ? '' : ' hide'}>REPORT</span>
                        {   (this.props.app.state.mode_report.status === false || 
                            (this.props.app.state.mode_report._is_share === false)) ?
                            (<Button 
                                type='primary' 
                                size='default' 
                                style={{ fontSize : 12, letterSpacing : 1, width : '100%'}} 
                                onClick={this.handleClickModal.bind(this, 'reports-new')} 
                                children={ this.state._report.edit === true ? 'UPDATE REPORT' : 'SAVE REPORT'} />) : null
                        }

                        {
                            (this.props.app.state.mode_report._is_invited === false )? 
                                (<Button 
                                    type='danger' 
                                    size='default' 
                                    style={{ 
                                        fontSize : 12, 
                                        marginTop : 10, 
                                        letterSpacing : 1, 
                                        width : '100%'
                                    }} 
                                    onClick={this.cancelReport.bind(this)}
                                    children={ this.state._report.edit === true ? 'CLOSE REPORT' : 'CANCEL REPORT'} />) : null
                        }
                        {
                            (
                                (this.state._report.edit === true && this.props.app.state.mode_report._is_share === false) || 
                                (this.props.app.state.mode_report._allow_export === 1 && this.props.app.state.mode_report._is_share === true) ||
                                (this.props.app.state.mode_report._allow_export === 1 && this.props.app.state.mode_report._is_invited === true)
                            ) ? 
                                <Button 
                                    style={{ 
                                        fontSize : 12, 
                                        marginTop : 20, 
                                        letterSpacing : 1, 
                                        width : '100%'
                                    }} 
                                    type='default'
                                    icon='export'
                                    size='default'
                                    onClick={() => {
                                        this._ExportReport.setState({
                                            visible : true
                                        })
                                    }}>
                                        EXPORT REPORT
                                    </Button> :
                                ''
                        }
                </div>
               {/*} <Popconfirm placement='rightTop' style={{width : 150}} title={<p>Some functions will be disabled.<br />Are you sure to activate the report generation context?</p>} onConfirm={this.confirm.bind(this, false)} okText='Yes' cancelText='No'>
                    <div className={(this.state._report.active === false ? '' : ' hide')}>
                        <a className='models'> <i className='fa fa-save' aria-hidden='true'></i> </a>
                        <span>NEW REPORT</span>
                    </div>
                </Popconfirm> */ }
            </div>
            <div className='with-love'>
                <div>
                    <span>Made with <i className='fa fa-heart'></i> by Axovia</span>
                </div>
            </div>
            <ExportReport app={this.props.app} ref={(child) => { this._ExportReport = child; }} />
        </section>
    )}
}

export default SidebarLeft


// WEBPACK FOOTER //
// ./src/Frontend/components/SidebarLeft.js